import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { unregister } from './serviceWorkerUnregister';

// Unregister service worker to allow browser native caching for images
// This prevents the service worker from intercepting Supabase image requests
// and allows the browser's memory/disk cache to work properly
unregister();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
); 